import { render, staticRenderFns } from "./OwnershipHistoryPage.vue?vue&type=template&id=4789dc18"
import script from "./OwnershipHistoryPage.vue?vue&type=script&lang=js"
export * from "./OwnershipHistoryPage.vue?vue&type=script&lang=js"
import style0 from "./OwnershipHistoryPage.vue?vue&type=style&index=0&id=4789dc18&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4789dc18')) {
      api.createRecord('4789dc18', component.options)
    } else {
      api.reload('4789dc18', component.options)
    }
    module.hot.accept("./OwnershipHistoryPage.vue?vue&type=template&id=4789dc18", function () {
      api.rerender('4789dc18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/use_cases/OwnershipHistoryPage.vue"
export default component.exports